import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Switch from '@material-ui/core/Switch';
import PrintjobPreview from './PrintjobPreview';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  settingsFormControl: {
    marginBottom: theme.spacing(3),
  },
});

class PrintSettingsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copies: props.copies || 1,
    };
  }

  handleCopiesChanged = (event) => {
    const value = event.target.value;
    if (value === '' || (parseInt(value) > 0 && parseInt(value) <= 100)) {
      this.setState({ copies: value });
    }
  };

  handleCopiesBlur = () => {
    const copies = parseInt(this.state.copies) || 1;
    this.setState({ copies: Math.max(1, Math.min(100, copies)) });
    this.props.onSettingsChanged({ copies: Math.max(1, Math.min(100, copies)) });
  };

  increaseCopies = () => {
    const newCopies = Math.min(100, (parseInt(this.state.copies) || 1) + 1);
    this.setState({ copies: newCopies });
    this.props.onSettingsChanged({ copies: newCopies });
  };

  decreaseCopies = () => {
    const newCopies = Math.max(1, (parseInt(this.state.copies) || 1) - 1);
    this.setState({ copies: newCopies });
    this.props.onSettingsChanged({ copies: newCopies });
  };

  render() {
    const { 
      classes, 
      t, 
      open, 
      onClose, 
      onSettingsChanged, 
      orderUrl, 
      id, 
      pageCount, 
      isGrayscale, 
      isDuplex, 
      disabled, 
      colorEnabled 
    } = this.props;
    const { copies } = this.state;

    return (
      <Dialog
        onClose={onClose}
        open={open}
        scroll='body'
        data-cy="settingsDialog"
      >
        <DialogTitle>
          {t('printSettings')}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item sm={6}>
              <FormControl fullWidth className={classes.settingsFormControl}>
                <InputLabel>{t('copies')}</InputLabel>
                <Input
                  type="text"
                  value={copies}
                  onChange={this.handleCopiesChanged}
                  onBlur={this.handleCopiesBlur}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        disabled={copies === 1}
                        onClick={this.decreaseCopies}
                      >
                        <RemoveIcon />
                      </IconButton>
                      <IconButton
                        disabled={copies === 100}
                        onClick={this.increaseCopies}
                      >
                        <AddIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <List>
                <ListItem>
                  <ListItemText primary={t('settingsColor')} />
                  <ListItemSecondaryAction>
                    <Switch
                      disabled={disabled || !colorEnabled}
                      onChange={(event, checked) => onSettingsChanged({ is_grayscale: !checked })}
                      checked={!isGrayscale}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem>
                  <ListItemText primary={t('duplex')} />
                  <ListItemSecondaryAction>
                    <Switch
                      disabled={disabled}
                      onChange={(event, checked) => onSettingsChanged({ is_duplex: checked })}
                      checked={isDuplex}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </Grid>
            <Grid item sm={6}>
              <PrintjobPreview
                id={id}
                orderUrl={orderUrl}
                pageCount={pageCount}
                isGrayscale={isGrayscale}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            color="primary"
            variant="contained"
            autoFocus
            data-cy="settingsDialog.okButton"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(withTranslation()(PrintSettingsDialog));
